import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';
import { ComicComponent } from './Pages/comic/comic.component';
import { HomeComponent } from './Pages/home/home.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatSelectModule} from '@angular/material/select';
import { AppConfigService } from './appconfigservice';
import { HttpClientModule} from '@angular/common/http';
import { CharactersComponent } from './Pages/characters/characters.component';
import { AboutComponent } from './Pages/about/about.component';
// import { ComicPageComponent } from './Pages/comic-page/comic-page.component';
//import { ComicNavBarComponent } from './Pages/comic-nav-bar/comic-nav-bar.component';
import { ComicImageComponent } from './Pages/comic-image/comic-image.component';
import { MerchandiseComponent } from './Pages/merchandise/merchandise.component';


@NgModule({
  declarations: [
    AppComponent,
    ComicComponent,
    HomeComponent,
    CharactersComponent,
    AboutComponent,
    // ComicPageComponent,
    //ComicNavBarComponent,
    ComicImageComponent,
    MerchandiseComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    HttpClientModule
  ],
  providers: [AppConfigService],
  bootstrap: [AppComponent]
})
export class AppModule { }
